import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { MESSAGES } from '../../../constants';
import { experiments } from '../../experiments';
import { selectItems } from '../selectors/chat';

const wixAiChatbot = experiments.is('specs.chatbot.WixAiChatbot', 'true');
const AI_NODE_ID = '4e10b675-d3d4-44ae-ab7d-9d795b5a2ce0';

export const useIsAiChatbot = () => {
  const items = useSelector(selectItems);
  const firstItem = items[0];

  return useMemo(
    // TODO: it will be shown by custom field from server, not a nodeId check
    () => wixAiChatbot && firstItem?.type === MESSAGES.BOT_MESSAGE && firstItem.nodeId === AI_NODE_ID,
    [firstItem],
  );
};
